export enum RelevanceEnum {
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D'
}
